import store from '@/store/index.js'
const authServer = process.env.VUE_APP_AUTH_HOST

export default class SecurityService {

  // Redirect of the current window to the authorization endpoint.
  signIn() {
    store.dispatch("user/removeProfile")
    store.dispatch("user/removeToken")
    store.dispatch("user/removeUser")
    store.dispatch("setting/removeSetting")
    window.location.href = `${authServer}/login`
  }

  // Redirect of the current window to the end session endpoint
  signOut() {
    store.dispatch("user/removeProfile")
    store.dispatch("user/removeToken")
    store.dispatch("user/removeUser")
    store.dispatch("setting/removeSetting")
    window.location.href = `${authServer}/logout`
  }

  // Get the user who is logged in
  getUser() {
    const self = this
    return new Promise((resolve, reject) => {
      fetch(`${authServer}/user`, {
          credentials: "include", // fetch won't send cookies unless you set credentials
        })
        .then((response) => response.json())
        .then((data) => {
          if (data == null || data.user == undefined || data.user == null) {
            self.signIn()
            return resolve(null)
          } else {
            const usr = Object.assign({}, data.user)
            data.user.profile = usr
            return resolve(data.user)
          }
        }).catch(function (err) {
          return reject(err)
        })
    })
  }

  // Check if there is any user logged in
  getSignedIn() {
    const self = this
    return new Promise((resolve, reject) => {
      fetch(`${authServer}/issignedin`, {
          credentials: "include", // fetch won't send cookies unless you set credentials
        })
        .then((response) => response.json())
        .then((data) => {
          if (data == null || data.user == undefined || data.user == null || !data.user.active) {
            self.signIn()
            return resolve(false)
          } else {
            return resolve(true)
          }
        }).catch(function (err) {
          return reject(err)
        })
    })
  }

  // Get the profile of the user logged in
  getProfile() {
    const self = this
    return new Promise((resolve, reject) => {
      fetch(`${authServer}/user`, {
          credentials: "include", // fetch won't send cookies unless you set credentials
        })
        .then((response) => response.json())
        .then((data) => {
          if (data == null || data.user == undefined || data.user == null) {
            self.signIn()
            return resolve(null)
          } else {
            return resolve(data.user)
          }
        }).catch(function (err) {
          return reject(err)
        })
    })
  }

  // Get the access token of the logged in user
  getAcessToken() {
    const self = this
    return new Promise((resolve, reject) => {
      fetch(`${authServer}/acctoken`, {
          credentials: "include", // fetch won't send cookies unless you set credentials
        })
        .then((response) => response.json())
        .then((data) => {
          if (data == null || data.token == undefined || data.token == null) {
            self.signIn()
            return resolve(null)
          } else {
            return resolve(data)
          }
        }).catch(function (err) {
          return reject(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/authService.js